<p>
    {{ 'auction.showing' | translate }}
    {{ paginationData?.from }}–{{ paginationData?.to }}
    {{ 'auction.of' | translate }} {{ paginationData?.total }}
    {{ 'auction.results' | translate }}
  </p>